module.exports = __webpack_public_path__ + "static/media/pointInterest.0f89a92c.svg";